import * as React from "react";

import { useComposedRefs } from "./use-composed-refs";

export function useStatefulElement<ElementType extends Element>(
  ref: React.RefObject<ElementType>,
): [ElementType | null, React.RefCallback<ElementType>] {
  const [element, setElement] = React.useState<ElementType | null>(null);
  const setElementRef = useComposedRefs(
    ref,
    // Legacy cast - may or may not be necessary
    // eslint-disable-next-line replo/no-as-cast
    setElement as React.RefCallback<ElementType>,
  );
  return [element, setElementRef];
}
